import { useForm, ValidationError } from "@formspree/react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import bgPattern from "../assets/colorful.png";
import { useEffect, useState } from "react";

export default function Contact() {
  const [state, handleSubmit] = useForm("mwpwoylw");
  const [showPopup, setShowPopup] = useState(false);
  const manrope = { fontFamily: "'Manrope', sans-serif" };

  // When submission succeeds, show popup
  useEffect(() => {
    if (state.succeeded) {
      setShowPopup(true);
    }
  }, [state.succeeded]);

  return (
    <div className="w-full bg-black relative">
      <Navbar />

      {/* Background Pattern */}
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(to bottom, black 0%, transparent 10%, transparent 90%, black 100%), url(${bgPattern})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%",
            backgroundPosition: "top center",
          }}
        />
      </div>

      {/* Overlay */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `
            linear-gradient(
              to bottom,
              rgba(0,0,0,0.5) 0%,
              rgba(0,0,0,0.6) 25%,
              rgba(0,0,0,0.7) 50%,
              rgba(0,0,0,0.6) 75%,
              rgba(0,0,0,0.5) 100%
            )
          `,
        }}
      />

      {/* Popup (success message) */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm text-center relative">
            <h2 className="text-2xl font-bold text-gray-900 mb-3">
              Merci pour votre message 🎉
            </h2>
           <p  className="text-base sm:text-lg md:text-p lg:text-p mb-6 mt-2 max-w-[700px]"
            style={manrope}>
              Nous vous répondrons dès que possible.
            </p>
            <button
              onClick={() => setShowPopup(false)}
              className="px-5 py-2 bg-[#158DC1] text-white rounded-[10px] hover:bg-[#0e6f97] transition"
            >
              Fermer
            </button>
          </div>
        </div>
      )}

      <main className="relative z-10 py-24 flex flex-col gap-20">
        <div className="relative z-10 mt-10 md:mt-24 max-w-5xl px-4 text-center mx-auto">
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Contactez-nous
          </h1>
          <p className="text-white text-lg sm:text-xl">
            Nous serons ravis de répondre à vos questions ou commentaires.
          </p>
        </div>

        <section className="relative z-10 w-full px-6 lg:px-16">
          <div className="bg-white rounded-2xl shadow-xl p-11 grid grid-cols-1 gap-12 max-w-5xl mx-auto">
            <h2 className="text-3xl font-bold mb-2 text-gray-900 text-center">
              Envoyez-nous un message
            </h2>

            <form onSubmit={handleSubmit} className="space-y-6 text-lg">
              <input
                id="name"
                type="text"
                name="name"
                placeholder="Votre nom"
                required
                className="w-full border border-gray-300 rounded-2xl px-6 py-4 focus:ring-2 focus:ring-indigo-500 outline-none text-lg bg-gray-100"
              />
              <ValidationError prefix="Name" field="name" errors={state.errors} />

              <input
                id="email"
                type="email"
                name="email"
                placeholder="Votre email"
                required
                className="w-full border border-gray-300 rounded-2xl px-6 py-4 focus:ring-2 focus:ring-indigo-500 outline-none text-lg bg-gray-100"
              />
              <ValidationError prefix="Email" field="email" errors={state.errors} />

              <textarea
                id="message"
                name="message"
                rows="5"
                placeholder="Votre message"
                required
                className="w-full border border-gray-300 rounded-2xl px-6 py-4 focus:ring-2 focus:ring-indigo-500 outline-none text-lg bg-gray-100"
              ></textarea>
              <ValidationError
                prefix="Message"
                field="message"
                errors={state.errors}
              />

              <button
                type="submit"
                disabled={state.submitting}
                className="px-6 py-3 bg-[#158DC1] text-lg w-full text-white rounded-[15px] hover:bg-white hover:text-[#158DC1] transition"
              >
                {state.submitting ? "Envoi en cours..." : "Envoyer"}
              </button>
            </form>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
